import React from 'react';
import { MuiGrid, MuiTypography } from '../../ui/MaterialUIComponents';

import lodash from 'lodash';
import en from 'date-fns/locale/en-US';
import format from 'date-fns/format';
import addDays from 'date-fns/addDays';
import { startOfWeek } from "date-fns";
import TimeSlotHeaderComponent from './TimeSlotHeaderComponent'
import DayComponent from './DayComponent'
class CalenderComponent extends React.Component {

  getTimeHeader(index) {
    index = index - 1;
    if (index === 0) {
      return '';
    }
    
    let indexin12 = index % 12 || 12;
    let ampm = " AM ";
    if (index >= 12) {

      ampm = " PM ";
    }

    return indexin12 + ampm;
  }

  getDayArray() {
    let tarray = this.props.calendarData.map((day, index) => {

      return <MuiGrid key={index} item xs>
        <DayComponent day={day} viewTimeTable={false} cellHeight={3}
          {...this.props} />
      </MuiGrid>
    });

    return tarray;
  }
  render() {

    const startTime = 0;
    const originDate = startOfWeek(new Date(), { weekStartsOn: 1 });
    return (
      <MuiGrid container direction="column" style={{ width: '100%' }} >
        <MuiGrid item xs={12} style={{ width: '100%' }} >
          <MuiGrid container>
            <MuiGrid item xs={1} style={{ border: '1px solid lightGray' }}></MuiGrid>
            {lodash.times(7).map(i => (
              <MuiGrid item
                key={i}
                style={{ border: '1px solid lightGray' }}
                xs
              >

                <MuiTypography variant="subtitle2" gutterBottom>{format(addDays(originDate, i), 'EEE', { locale: en })}</MuiTypography>

              </MuiGrid>
            ))}
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container style={{ width: "100%", maxHeight: '60vh', overflowY: 'auto' }} id='scrollStyleWithoutDisplay'>
          <MuiGrid item xs={1}>
            {lodash.times(24).map(i => (

              <TimeSlotHeaderComponent key={i++} label={this.getTimeHeader(i++)} />

            ))}

          </MuiGrid>
          {this.getDayArray()}

        </MuiGrid>
      </MuiGrid>
    )
  }
}

export default CalenderComponent;
